module.exports = __webpack_public_path__ + "static/img/princesshappy.35acb87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/memes/princesshappy.jpg
// module id = wubB
// module chunks = 1